import { all, takeEvery } from 'redux-saga/effects';

import services from '../services';
import EntryActionTypes from '../../../constants/EntryActionTypes';

export default function* listReportDataWatchers() {
  yield all([
    takeEvery(
      EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_FETCH,
      () => services.fetchListReportDataInCurrentList(),
    ),
    takeEvery(
      EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_UPSERT,
      ({ payload: { data } }) => services.upsertListReportDataInCurrentList(data),
    ),
    takeEvery(
      EntryActionTypes.LIST_REPORT_DATA_IN_CURRENT_LIST_COMPLETE,
      () => services.completeListReportDataInCurrentList(),
    ),
    takeEvery(
      EntryActionTypes.LIST_REPORT_DATA_BY_LIST_ID_UPSERT,
      ({ payload: { listId, data } }) => services.upsertListReportDataByListId(listId, data),
    ),
    takeEvery(
      EntryActionTypes.LIST_REPORT_DATA_BY_LIST_ID_COMPLETE,
      ({ payload: { listId } }) => services.completeListReportDataByListId(listId),
    ),
  ]);
}
